import react from "react";
import "./styles.css";
import team from "../../../img/banner-horizontal.jpg";
import team2 from "../../../img/about/banner-nosotros2.png";
import team3 from "../../../img/about/banner-nosotros3.png";
import teamMob from "../../../img/about/banner-nosotros-mobile.png";
import teamMob2 from "../../../img/about/banner-nosotros-mobile2.png";
import teamMob3 from "../../../img/about/banner-nosotros-mobile3.png";

export const SliderTeam = () => {
  return (
    <div>
      <div
        id="carouselExampleIndicators"
        class="carousel slide"
        data-bs-ride="true"
      >
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src={team} className="d-block w-100 web-about" alt="..." />
            <img src={teamMob} className="d-block w-100 mob-about" alt="..." />
          </div>
          <div class="carousel-item">
            <img src={team2} className="d-block w-100 web-about" alt="..." />
            <img src={teamMob2} className="d-block w-100 mob-about" alt="..." />
          </div>
          <div class="carousel-item">
            <img src={team3} className="d-block w-100 web-about" alt="..." />
            <img src={teamMob3} className="d-block w-100 mob-about" alt="..." />
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};
